import React from 'react';

export const ICON_VARIANT_TYPE = {
  MODAL_CLOSE: 'modal-close',
  EXTERNAL_VERIFICATION: 'external-verification',
} as const;

export type IconVariant = typeof ICON_VARIANT_TYPE[keyof typeof ICON_VARIANT_TYPE];

interface IconsProps extends React.SVGProps<SVGSVGElement> {
  variant?: IconVariant;
  size?: number;
}

export const Icons = ({ variant, size = 16, ...props }: IconsProps) => {
  const getIcons = () => {
    switch (variant) {
      case ICON_VARIANT_TYPE.MODAL_CLOSE: {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            {...props}
          >
            <g clipPath="url(#clip0_42719_6422)">
              <path
                d="M24 8L8 24"
                stroke={props.stroke || '#515151'}
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M8 8L24 24"
                stroke={props.stroke || '#515151'}
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </g>
            <defs>
              <clipPath id="clip0_42719_6422">
                <rect width="32" height="32" fill="white" />
              </clipPath>
            </defs>
          </svg>
        );
      }
      case ICON_VARIANT_TYPE.EXTERNAL_VERIFICATION: {
        return (
          <svg
            width="52"
            height="52"
            viewBox="0 0 52 52"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clipPath="url(#clip0_17725_401747)">
              <rect width="52" height="52" rx="26" fill="#04A451" fillOpacity="0.1" />
              <rect
                x="12"
                y="14"
                width="28"
                height="43"
                rx="6"
                fill="white"
                stroke="#04A451"
                strokeWidth="2"
              />
              <path d="M23 18H29" stroke="#04A451" strokeWidth="2" strokeLinecap="round" />
              <rect opacity="0.1" x="16" y="23" width="20" height="5" rx="1" fill="#04A451" />
              <rect opacity="0.1" x="16" y="31" width="20" height="23" rx="1" fill="#04A451" />
            </g>
            <defs>
              <clipPath id="clip0_17725_401747">
                <rect width="52" height="52" rx="26" fill="white" />
              </clipPath>
            </defs>
          </svg>
        );
      }
      default: {
        return <></>;
      }
    }
  };

  return getIcons();
};
